import { FetchResult, FetchStatus } from "../base/types";

import { IPage } from "../design/page/models";
import { IUserModel } from "../../modules/auth";
import Logger from "../../helpers/Logger";
import { useLazyGetPageMetadataQuery } from "../services/data";
import { useLazyGetSiteQuery } from "../services/auth";
import { useState } from "react";

type TDashboardPageResult = [
    getDashboardPage: (siteId: string, user?: IUserModel) => Promise<IPage>,
    result: FetchResult<IPage>
]

export const useGetDashboardPage = (): TDashboardPageResult => {
    const [getPageMetadataQuery] = useLazyGetPageMetadataQuery();
    const [getSite] = useLazyGetSiteQuery();

    const [status, setStatus] = useState<FetchResult<IPage>>({ status: FetchStatus.Idle })

    const getDashboardPage = (siteId: string, user?: IUserModel) => {
        setStatus({ status: FetchStatus.Loading })
        return getDashboardPageId(siteId, user)
            .then(pageId => getPageMetadataQuery(pageId, true)
                .unwrap()
                .then(page => {
                    setStatus({ status: FetchStatus.Success, result: page })
                    return Promise.resolve(page)
                })
            )
            .catch(err => {
                const message = err.data.message || 'An error occurred while loading dashboard page. Please try again later.'
                setStatus({ status: FetchStatus.Error, error: message })
                return Promise.reject(message);
            })
    }

    const getDashboardPageId = (siteId: string, user?: IUserModel): Promise<string> => {
        if (user) {
            if (user.dashboardPageId)
                return Promise.resolve(user?.dashboardPageId)
            console.log("user.memberOf", user.memberOf)
            const member = user.memberOf.find(p => p.portalId === siteId)
            if (member?.dashboardPageId)
                return Promise.resolve(member?.dashboardPageId)
        }

        Logger.info(`Loading site id: ${siteId}`)
        return getSite(siteId)
            .unwrap()
            .then(({ dashboardPageId }) => dashboardPageId)

    }

    return [getDashboardPage, status];
}